export default __webpack_public_path__ + "static/media/pdf.7e2327a4.png";